const SET_USER = (state, user) => {
	state.user = user
}

const SET_ACCESS_TOKEN = (state, token) => {
	state.accessToken = token
}

const DELETE_TOKEN = (state) => {
	state.accessToken = null
}

export default {
	SET_USER,
	SET_ACCESS_TOKEN,
	DELETE_TOKEN,
}
